import { CheckMark, ExclamationMark } from '@vivino/js-web-common';
import cx from 'classnames';
import React, { ComponentProps, FormEventHandler } from 'react';
import Input from 'vivino-ui/atoms/Input';
import Spinner from 'vivino-ui/icons/Spinner';

import styles from './zipCodeInput.scss';

interface IZipCodeInputProps extends ComponentProps<typeof Input> {
  hasError?: boolean;
  isValid?: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
  showCountryFlag?: boolean;
  isValidating?: boolean;
}

const ZipCodeInput = ({
  placeholder,
  hasError,
  isValid,
  onSubmit,
  onChange,
  onBlur,
  value,
  maxLength,
  showCountryFlag,
  isValidating,
}: IZipCodeInputProps) => {
  return (
    <form onSubmit={onSubmit} autoComplete={'off'}>
      <Input
        id="zip"
        name="zip"
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        maxLength={maxLength}
        className={cx(styles.zipCode, {
          [styles.withCountryFlag]: showCountryFlag,
        })}
      />
      <div>
        {isValidating && <Spinner className={styles.spinner} />}
        {!isValidating && isValid && <CheckMark className={styles.checkMark} />}
        {!isValidating && hasError && <ExclamationMark className={styles.exclamationMark} />}
      </div>
    </form>
  );
};

export default ZipCodeInput;
